import {PHASES, WAR_PHASE_STAGES} from '../../constants/phases';
import {getPlayerHexColor} from '../players/getPlayerHexColor';
import {getGameUiPhaseColor} from './gameUiPhaseColors';

/**
 * Цвет эмали кнопки хода (требование «Цвет игрока для „моего“»):
 *  - свой ход — цвет текущей фазы (в hot-seat ход всегда свой);
 *  - снабжение — всегда цвет фазы снабжения, в том числе в ожидании;
 *  - ход соперника — его цвет; у зрителя — цвет ходящего;
 *  - ближний бой, который игрок еще не подтвердил, — цвет фазы и в чужой фазе
 *    войны: подтвердить бой — его ход, кнопку надо нажать;
 *  - подтвержденный ближний бой — по игроку, чья идет фаза войны, а не по
 *    ожидаемому: бой — часть его фазы. Своя фаза войны — цвет фазы, чужая —
 *    цвет ее владельца.
 * Цвета фаз — те же токены, что у шапки (GAME_UI_PHASE_COLORS).
 *
 * @param {Object} params
 * @param {string} params.phase - PHASES
 * @param {string|null} params.warPhaseStage - WAR_PHASE_STAGES
 * @param {Object|null} params.gameResults - итоги партии
 * @param {boolean} params.isOwnTurn - ход этого клиента: кнопку можно нажать
 * @param {Object|null} params.turnPlayer - чей ход показывает кнопка (кого ждем)
 * @param {Object|null} params.warPhasePlayer - чья идет фаза войны (текущий игрок)
 * @param {string|null} params.ownPlayerId - свой игрок клиента; у зрителя null
 * @returns {string} цвет в CSS-формате
 */
export const getCompleteButtonColor = ({
  phase,
  warPhaseStage,
  gameResults,
  isOwnTurn,
  turnPlayer,
  warPhasePlayer,
  ownPlayerId,
}) => {
  const phaseColor = getGameUiPhaseColor(phase, gameResults);
  if (gameResults || phase === PHASES.SUPPLY) {
    return phaseColor;
  }

  if (phase === PHASES.WAR && warPhaseStage === WAR_PHASE_STAGES.COMBAT && warPhasePlayer) {
    // У зрителя своего хода нет: ему — всегда владелец фазы войны
    if (isOwnTurn && ownPlayerId) {
      return phaseColor;
    }
    return warPhasePlayer.id === ownPlayerId ? phaseColor : getPlayerHexColor(warPhasePlayer.color);
  }

  if (isOwnTurn || !turnPlayer) {
    return phaseColor;
  }
  return getPlayerHexColor(turnPlayer.color);
};
